export const TEAM9_APP_VERSION =
  (import.meta.env.VITE_APP_VERSION as string | undefined) || "0.1.0";
